let pendingChatbotUpload = null;

export const setPendingChatbotUpload = (payload = {}) => {
  pendingChatbotUpload = {
    ...payload,
    files: Array.isArray(payload.files) ? payload.files : [],
  };
};

export const consumePendingChatbotUpload = (expectedAction) => {
  if (!pendingChatbotUpload) return null;
  if (expectedAction && pendingChatbotUpload.action !== expectedAction) {
    return null;
  }

  const payload = pendingChatbotUpload;
  pendingChatbotUpload = null;
  return payload;
};

export const clearPendingChatbotUpload = () => {
  pendingChatbotUpload = null;
};
